


















































































































































































import CardPanel from '@/components/common/CardPanel.vue'
import {Component, Ref} from 'vue-property-decorator'
import RouterHelper from '@/mixins/RouterHelper.vue'
import SimpleUploader from "@/components/common/SimpleUploader.vue"
import {ElForm} from 'element-ui/types/form'
import {getDataContent} from '@/request/apis/common'
import {createTask} from '@/request/apis/TrajectoryAnalysisRequest'
import ParamsDialogWrapper from "@/components/common/ParamsDialogWrapper.vue"
import CascaderSelect from "@/components/common/CascaderSelect.vue";

const formParams = require('./trajecory_params.json')
@Component({
  components: {
    CascaderSelect,
    CardPanel,
    SimpleUploader,
    ParamsDialogWrapper
  }
})
export default class TrajectoryAnalysisForm extends RouterHelper {
  @Ref('form') readonly submitForm!: ElForm
  @Ref('textarea') readonly textarea!: HTMLInputElement

  private clusterNameList: any[] = []
  private formParams: any[] = formParams.children
  private loadingProcessButton: boolean = false
  private type: string = 'TrajectoryAnalysis'

  private form: any = {
    inputType: 'choose', // choose | file
    chooseData: '', // 选择的数据
    dataID: '', //上传的文件ID
    content: '', // 文本内容
    chooseMethod: 'PAGA', // FLE | PAGA
    rootCellSelect: 'auto' // auto | manual
  }

  get id() {
    return this.$route.params.id
  }

  /**
   * 级联选择器数据改变
   */
  private async handleDataChange(value: string) {
    this.form.chooseData = value
    await this.getContent()
  }

  /**
   * 根据选择数据获取文本内容
   */
  private async getContent () {
    const res = await getDataContent(this.textarea, this.form.chooseData).start()
    this.form.content = res.content
    this.clusterNameList = res.cluster_name_list
  }

  /**
   * 表单提交
   */
  private submitHandler() {
    this.submitForm.validate(async (valid) => {
      if (valid) {
        this.loadingProcessButton = true
        try {
          let params: any = {
            job_id: this.id,
            choose_method: this.form.chooseMethod,
          }
          if (this.form.inputType === 'file') {
            params.choose_data = this.form.dataID
          } else {
            params.choose_data = this.form.chooseData
          }
          this.formParams.map((item: any) => {
            if(item.name === this.form.chooseMethod) {
              item.children.map((child: any) => {
                const prop: {[key: string]: any} = {}
                if (child.isNeeded === true) {
                  child.parameters.map((param: any) => {
                    prop[param.name] = param.value
                  })
                  params[child.name] = JSON.stringify({
                    isNeeded: child.isNeeded,
                    parameters: prop
                  })
                }
                else if (child.isNeeded === false) {
                  params[child.name] = JSON.stringify({
                    isNeeded: child.isNeeded
                  })
                }
              })
            }
          })
          const taskDetail = await createTask(null, params).start()
          this.$emit('formSubmit', taskDetail)
        } catch (e) {
          console.warn(e)
        }
        this.loadingProcessButton = true
      } else {
        return false
      }
    })
  }

  private get rules() {
    const checkInputData = (rule: any, value: string, callback: Function) => {
      if (this.form.inputType === 'choose' && !value) {
        return callback(new Error(<string>this.$t('form.choose')))
      }
      callback()
    }
    const checkFile = (rule: any, value: string, callback: Function) => {
      if (this.form.inputType === 'file' && !this.form.dataID) {
        return callback(new Error(<string>this.$t('form.upload')))
      }
      callback()
    }
    const _this = this
    let formRules: {[key: string]: any} = {}
    formRules['chooseData'] = [{ validator: checkInputData, trigger: 'blur' }]
    formRules['fileId'] = [{ validator: checkFile, trigger: 'blur' }]
    this.formParams.map((item: any) => {
      if(item.name === this.form.chooseMethod) {
        item.children.map((child: any) => {
          if(child.isNeeded) {
            child.parameters.map((param: any) => {
              formRules[param.prop] = [{
                validator: function (rule: any, value: any, callback: Function) {
                  if (param.type === 'number') {
                    if (param.max_value === 'Infinity') param.max_value = +Infinity
                    if (param.value < param.min_value || param.value > param.max_value || param.value == null)
                      if (param.default_none && param.value === -1) callback() //默认None 值为-1
                      else callback(new Error(<string>_this.$t('form.params.checkRange',{ min: param.min_value, max: param.max_value })))
                  }
                  if (param.type === 'input') {
                    const pattern = /^[0-9A-Za-z._-]+$/
                    if (!param.value || !pattern.test(param.value)) {
                      callback(new Error(<string>_this.$t('form.params.checkPattern')))
                    }
                  }
                  if (param.type === 'select') {
                    if (!param.value) {
                      callback(new Error(<string>(`Please choose ${param.display_name}`)))
                    }
                  }
                  if (param.type === 'input_list') {
                    const pattern = /^[0-9A-Za-z_., -*]+$/
                    if (!param.value || !pattern.test(param.value)) {
                      callback(new Error(<string>_this.$t('form.params.checkListPattern')))
                    }
                  }
                  callback()
                }, trigger: param.type === 'input' ? 'blur':'change'}]
            })
          }
        })
      }
    })
    return formRules
  }
}
